import React from "react";
import DashboardPart from "./DashbordPart";
import Approve from "../../Images/stamp.png";

const DashboardApproved = ({ dashboardTotalInfo }) => {

  return (
    <DashboardPart
      DashboardHeading="Total Approved Volunteer"
      DashboardValue={dashboardTotalInfo.total_vol_approved}
      Icon={Approve}
      style={{ background: "linear-gradient(to right, #155799, #159957)" }}
    />
  );
};

export default DashboardApproved;
